import ApplicationController from '../application_controller'

const ATTACHMENTS_PER_PAGE = 15
class ShareProfileAttachmentsController extends ApplicationController {
  static targets = ['container']
  static values = { url: String, tagName: String }

  connect () {
    this.inputs = []

    $(this.containerTarget).select2({
      ajax: {
        url: this.urlValue,
        quietMillis: 250,
        dataType: 'json',
        data: (term, page) => {
          return { description: term, page, per_page: ATTACHMENTS_PER_PAGE }
        },
        results: (data, _page) => {
          const more = data.data.length === ATTACHMENTS_PER_PAGE
          return { results: data.data, more }
        }
      },
      multiple: true,
      placeholder: I18n.t('attachment_relations.share_attachments_placeholder'),
      formatResult: this._formatResult,
      formatSelection: this._formatResult
    }).on('change', this._onChange.bind(this))
  }

  _formatResult (option) {
    return `
      <div class="attachments-select2-preview">
        <div class="img">
          <img src="${option.preview_icon_url}"/>
        </div>

        <div class="details">
          <div class="filename">${option.filename}</div>
        </div>
      </div>
    `
  }

  _onChange (e) {
    this.inputs.forEach(input => input.remove())
    this.inputs = []

    e.val.forEach((val) => {
      const input = document.createElement('input')

      input.setAttribute('type', 'hidden')
      input.setAttribute('name', this.tagNameValue)
      input.setAttribute('value', val)

      this.inputs.push(input)
    })

    $(this.element).append(this.inputs)
  }
}

export default ShareProfileAttachmentsController
